document.addEventListener('change', (event) => {
  const select = event.target.closest('[data-ssc-sort]');
  if (!select) return;
  const url = new URL(window.location.href);
  url.searchParams.set('sort_by', select.value);
  url.searchParams.delete('page');
  window.location.assign(url.toString());
});

// Phone Filter pill in the anime row (prompt 117, sections/ssc-anime-filter.liquid): opens the filter drawer through the
// Filter button it replaces (hidden on phones). No drawer on the page = no pill.
document.querySelectorAll('[data-ssc-open-filters]').forEach((pill) => {
  const drawer = document.getElementById('filters-drawer');
  if (!drawer) {
    pill.hidden = true;
    return;
  }
  pill.addEventListener('click', () => {
    const button = document.querySelector('.facets-toggle__button');
    if (button) button.click();
    else if (typeof drawer.open === 'function') drawer.open();
  });
});

function sscFitColTitles() {
  document.querySelectorAll('[data-ssc-fit-title]').forEach((title) => {
    title.style.fontSize = '';
    let size = parseFloat(getComputedStyle(title).fontSize);
    const min = 24;
    while (size > min && title.scrollWidth > title.clientWidth + 1) {
      size -= 1;
      title.style.fontSize = size + 'px';
    }
  });
}
sscFitColTitles();
window.addEventListener('resize', sscFitColTitles);

document.querySelectorAll('[data-ssc-desc]').forEach((wrap) => {
  const text = wrap.querySelector('[data-ssc-desc-text]');
  const more = wrap.querySelector('[data-ssc-desc-more]');
  if (!text || !more) return;
  if (text.scrollHeight > text.clientHeight + 2) more.hidden = false;
  more.addEventListener('click', () => {
    text.classList.add('is-open');
    more.hidden = true;
  });
});

(function () {
  const root = document.querySelector('[data-ssc-anime]');
  if (!root) return;
  const pills = [...root.querySelectorAll('[data-ssc-series]')];
  let cards = [...document.querySelectorAll('.product-grid__item[data-ssc-handle]')];
  const empty = root.querySelector('[data-ssc-anime-empty]');
  const dataEl = document.getElementById('ssc-anime-series');
  if (!pills.length || !cards.length || !dataEl) return;
  let designs = [];
  try {
    designs = JSON.parse(dataEl.textContent);
  } catch (error) {
    designs = [];
  }
  designs.sort((a, b) => b.design.length - a.design.length);
  const prepared = designs.map((item) => ({ needle: item.design.toLowerCase(), series: item.series }));
  const counts = { __all__: 0 };
  let selected = '__all__';
  function tag(card) {
    const title = (card.dataset.sscTitle || '').toLowerCase();
    let match = 'Unknown';
    for (const item of prepared) {
      if (title.includes(item.needle)) {
        match = item.series;
        break;
      }
    }
    card.dataset.sscSeries = match;
    counts[match] = (counts[match] || 0) + 1;
    counts.__all__ += 1;
  }
  function paintCounts() {
    pills.forEach((pill) => {
      const key = pill.dataset.sscSeries;
      if (key === '__all__') return;
      const count = pill.querySelector('[data-ssc-count]');
      const total = counts[key] || 0;
      if (count && !count.hasAttribute('data-ssc-filter')) count.textContent = `(${total})`;
      // Pills with the filter's own count (the whole collection) never hide; the others show once a card matches.
      pill.hidden = total === 0 && !(count && count.hasAttribute('data-ssc-filter'));
    });
  }
  cards.forEach(tag);
  paintCounts();
  // Prompt 129: Filter / Sort re-render the grid with new card nodes, so the cards are read again before each use (the
  // first list went stale: pills stopped filtering after any filter change until a reload).
  function sync() {
    const live = [...document.querySelectorAll('.product-grid__item[data-ssc-handle]')];
    if (live.length === cards.length && live.every((card, index) => card === cards[index])) return;
    cards = live;
    Object.keys(counts).forEach((key) => delete counts[key]);
    counts.__all__ = 0;
    cards.forEach(tag);
    paintCounts();
  }
  function apply(series) {
    sync();
    let visible = 0;
    cards.forEach((card) => {
      const show = series === '__all__' || card.dataset.sscSeries === series;
      card.style.display = show ? '' : 'none';
      if (show) visible += 1;
    });
    // While more pages are still to load (assets/ssc-more.js), the series may be further down: no empty message yet.
    if (empty) empty.hidden = visible !== 0 || !!document.querySelector('a.ssc-load-more[data-ssc-more]');
    document.querySelectorAll('.product-grid .ssc-pt-cell').forEach((tile) => {
      tile.hidden = series !== '__all__';
    });
  }
  pills.forEach((pill) => {
    pill.addEventListener('click', () => {
      pills.forEach((item) => {
        item.classList.remove('is-selected');
        item.setAttribute('aria-pressed', 'false');
      });
      pill.classList.add('is-selected');
      pill.setAttribute('aria-pressed', 'true');
      selected = pill.dataset.sscSeries;
      apply(selected);
    });
  });
  // Prompt 121: cards loaded near the end of the grid (assets/ssc-more.js) join the picked series.
  document.addEventListener('ssc:grid-more', (event) => {
    apply(selected);
  });
  // Filter / Sort results: keep the picked series applied to the new cards.
  const results = document.querySelector('results-list') || document.querySelector('.product-grid')?.parentElement;
  if (results) {
    let queued = false;
    new MutationObserver(() => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(() => {
        queued = false;
        apply(selected);
      });
    }).observe(results, { childList: true, subtree: true });
  }
})();

// Flagship collection (prompt 90): #1-#3 "BEST SELLER" stickers on the first three top sellers, a black "Top seller" chip on
// the other top sellers, a "Ready in 24h" chip on the US-stock picks, and the All / Shorts / Tops pills. Data comes from
// sections/ssc-collection-header.liquid (#ssc-flagship-data); the overlays are absolutely placed, so nothing moves.
(function () {
  const dataEl = document.getElementById('ssc-flagship-data');
  if (!dataEl) return;
  let map = {};
  try {
    map = JSON.parse(dataEl.textContent);
  } catch (error) {
    return;
  }
  const SHORTS = /shorts|leggings/i;
  let filter = 'all';

  function decorate(item) {
    if (item.dataset.sscFlag) return;
    const info = map[item.dataset.sscHandle];
    const gallery = item.querySelector('.card-gallery');
    if (!info || !gallery) return;
    item.dataset.sscFlag = info.g;
    if (info.g === 'top' && info.r && info.r <= 3) {
      const sticker = document.createElement('span');
      sticker.className = 'ssc-flag-rank';
      sticker.textContent = `#${info.r}`;
      const small = document.createElement('small');
      small.textContent = 'BEST SELLER';
      sticker.append(' ', small);
      gallery.append(sticker);
      return;
    }
    const chip = document.createElement('span');
    if (info.g === 'top') {
      chip.className = 'ssc-flag-chip ssc-flag-chip--top';
      chip.textContent = 'Top seller';
    } else {
      chip.className = 'ssc-flag-chip';
      const dot = document.createElement('i');
      dot.setAttribute('aria-hidden', 'true');
      chip.append(dot, 'Ready in 24h');
    }
    gallery.append(chip);
  }

  function apply() {
    document.querySelectorAll('.product-grid__item[data-ssc-handle]').forEach((item) => {
      decorate(item);
      const shorts = SHORTS.test(item.dataset.sscType || '');
      const show = filter === 'all' || (filter === 'shorts' ? shorts : !shorts);
      item.style.display = show ? '' : 'none';
    });
    // Promo tiles (prompt 94) step aside while a pill filters the grid, so two never end up side by side.
    document.querySelectorAll('.product-grid .ssc-pt-cell').forEach((tile) => {
      tile.hidden = filter !== 'all';
    });
  }

  document.querySelectorAll('[data-ssc-flag-filter]').forEach((pill, i, pills) => {
    pill.addEventListener('click', () => {
      filter = pill.dataset.sscFlagFilter;
      pills.forEach((item) => {
        item.classList.toggle('is-selected', item === pill);
        item.setAttribute('aria-pressed', String(item === pill));
      });
      apply();
    });
  });

  apply();
  // Sorting / filtering re-renders the grid: decorate the new cards too.
  const list = document.querySelector('results-list');
  if (list) {
    let queued = false;
    new MutationObserver(() => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(() => {
        queued = false;
        apply();
      });
    }).observe(list, { childList: true, subtree: true });
  }
})();

// Promo tiles (prompt 94, snippets/ssc-promo-tile.liquid): the Anime Wars tile fills in the live matchup from the board
// assets/ssc-wars.js already loads (same 5-minute session cache). Generic: the top 2 worlds. On a world's collection:
// that world vs the leader (or vs #2 when it leads). Text only, fixed boxes, so nothing moves; no board = it stays as is.
(function () {
  const tiles = [...document.querySelectorAll('[data-ssc-pt-wars]')];
  if (!tiles.length) return;
  let tries = 0;
  function start() {
    const wars = window.SSCWars;
    if (!wars || typeof wars.loadBoard !== 'function') {
      if (++tries < 60) setTimeout(start, 250); // ssc-wars.js boots on idle
      return;
    }
    wars.loadBoard().then(fill).catch(() => {});
  }
  function fill(board) {
    const seen = {};
    const list = ((board && board.anime) || [])
      .map((a) => ({ key: a.world_key, v: Number(a.total) || 0 }))
      .filter((x) => x.key && x.key !== 'default')
      .sort((x, y) => y.v - x.v)
      .filter((x) => (seen[x.key] ? false : (seen[x.key] = true)));
    if (!list.length || !list[0].v) return;
    const id = board.season && board.season.id;
    const month = id ? new Date(`${id}-15T12:00:00Z`).toLocaleString('en-US', { month: 'short', timeZone: 'UTC' }) : '';
    tiles.forEach((tile) => {
      const labels = {};
      (tile.dataset.labels || '').split('|').forEach((row) => {
        const [k, v] = row.split('=');
        if (k) labels[k] = v;
      });
      const name = (k) => labels[k] || k;
      const lead = list[0];
      const me = tile.dataset.world ? list.find((x) => x.key === tile.dataset.world) : null;
      let a = lead;
      let b = list[1] || null;
      let head = `${name(lead.key)} are winning`;
      let sub = b ? `${lead.v - b.v} votes ahead` : `${lead.v} votes`;
      if (me && me.v > 0) {
        const rank = 1 + list.filter((x) => x.v > me.v).length;
        a = me;
        b = rank === 1 ? list.find((x) => x.key !== me.key) || null : lead;
        head = `${name(me.key)} are #${rank}`;
        sub = rank === 1 ? `${me.v} votes · leading` : `${lead.v - me.v} behind ${name(lead.key)}`;
      }
      const set = (sel, text) => {
        const node = tile.querySelector(sel);
        if (node) node.textContent = text;
      };
      set('[data-ssc-pt-head]', head);
      set('[data-ssc-pt-n1]', name(a.key));
      set('[data-ssc-pt-v1]', String(a.v));
      set('[data-ssc-pt-n2]', b ? name(b.key) : '—');
      set('[data-ssc-pt-v2]', b ? String(b.v) : '–');
      set('[data-ssc-pt-sub]', sub);
      if (month) set('[data-ssc-pt-month]', month);
      const bar = tile.querySelector('[data-ssc-pt-bar]');
      if (bar) bar.style.width = `${Math.round((a.v / Math.max(1, a.v + (b ? b.v : 0))) * 100)}%`;
      tile.setAttribute('aria-label', `Anime Wars: ${head}. See the war`);
    });
  }
  start();
})();

// Breadcrumbs (prompt 96): remember this collection's path and heading, so a product page opened from here can name it
// in its trail (assets/ssc-keep-going.js).
(function () {
  const h = document.querySelector('.ssc-colhead__title');
  if (!h || !/^\/collections\/[^/]+\/?$/.test(location.pathname)) return;
  try {
    sessionStorage.setItem('ssc-last-collection', JSON.stringify({ path: location.pathname.replace(/\/$/, ''), title: h.textContent.trim() }));
  } catch (e) { /* private mode */ }
})();
